import { render, staticRenderFns } from "./MyPage.vue?vue&type=template&id=36a91cd6&"
import script from "./MyPage.vue?vue&type=script&lang=js&"
export * from "./MyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports